import { fetchResource, postResource } from '@/services/fetchService.js'

const headers = [
  { text: 'post.thumbnail', name: 'thumbnail', sortable: false, filterable: false },
  { text: 'post.title', name: 'title' },
  { text: 'post.episode', name: 'episode' },
  { text: 'post.postType', name: 'postType' },
  { text: 'post.author', name: 'author' },
  { text: 'post.topic', name: 'topic' },
  { text: '', name: 'data-table-expand' }
]
class PostService {
  constructor() {
    this.type = ''
  }

  fetchPosts = async ({ filter }) => {
    const params = { filter }
    const posts = await fetchResource('posts', params)
    return posts
  }

  fetchPost = async ({ id, slug }) => {
    const resource = 'post'
    const path = id ? `${resource}/${id}` : `${resource}/slug/${slug}`
    const post = await fetchResource(path)
    return post
  }

  getPostHeaders = () => {
    return JSON.parse(JSON.stringify(headers))
  }

  incrementLikes = async ({ postId, deltaLikes }) => {
    const queryParams = deltaLikes ? `?inc=${deltaLikes}` : ''
    const resource = `post/${postId}/likes${queryParams}`
    const { id, likes } = await postResource(resource, {})
    return { id, likes }
  }
}

export default PostService
export const postService = new PostService()
